import axios from 'axios';
import { getData, postData, putData } from './redux_data';
import {
    GET_MAQUINAS_OF_MAE_MAQUINA, GET_MAQUINA_DETALLES, MODIFY_FIELD_DETALLE_MAQUINA, ADD_NEW_MAQUINA, DELETE_MAQUINA, UPDATE_DETALLES_MAQUINA, UPDATE_DETALLES_NEW_MAQUINA, GET_MAQUINAS_CENTRO_ORIGEN, GET_MAQUINAS_CENTRO_DESTINO, MOVE_MAQUINA_TO_CENTRO_DESINO, OPEN_DIALOG

} from '../constants/action_types';

import * as config from '../constants/configuration';

export function getMaquinas(alta) {
    return getData(`vmaquinas/${alta}`, GET_MAQUINAS_OF_MAE_MAQUINA);
};

export function getMaquinaDetalles(maquinaId) {

    return getData('vmaquinadetalle/' + maquinaId, GET_MAQUINA_DETALLES);

};

export function modifyFieldDetalleMaquina(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELD_DETALLE_MAQUINA, payload: [field, value] })
    };
};

export function addNewMaquina(defaultModel, defaultCenter, regInterno) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_NEW_MAQUINA, payload:{defaultModel, defaultCenter, regInterno } });
    };
};

//delete a maquina from DB (DELETE):
export function deleteMaquinaDB(id) {

    return (dispatch, getState) => {
        dispatch({ type: DELETE_MAQUINA, payload: id })
        let token = getState().oidc.user ? getState().oidc.user.access_token : "";
        axios.delete(config.API_URI() + `vmaquinas/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        ).then((response) => {
            dispatch({ type: DELETE_MAQUINA + "_SUCCESS", payload: response })

        }).catch((error) => {
            if (error.response.status === 409) {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_maquina_' + id
                });
            }
            else {
                dispatch({
                    type: OPEN_DIALOG,
                    modalType: 'SimpleMessage',
                    modalProps: { message: error.response.data.message, exception: error.response.data.ex },
                    dialogid: 'error_delete_maquina_' + id
                });
            };
        });
    };
};


//update changes of an edited maquina (PUT):
export function updateDetallesMaquinaDB(maquina, id, thenHandler) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_DETALLES_MAQUINA, payload: id })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.put(config.API_URI() + 'vmaquinadetalle/' + id, maquina,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_DETALLES_MAQUINA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_maquina_' + id
    //         });
    //     }).catch((error) => {
    //         if (error.response.status === 409) {

    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_maquina_' + id
    //             });
    //         }
    //         else {
    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_maquina_' + id
    //             });
    //         };
    //     });
    // };

    return putData('vmaquinadetalle', UPDATE_DETALLES_MAQUINA, maquina, id, 'Máquina actualizada', thenHandler);

};


//save NEW maquina (POST):
export function NewMaquinaDB(maquina, id, fecha, thenHandler) {
    
    return postData('vmaquinadetalle?fecha_alta=' + fecha, UPDATE_DETALLES_NEW_MAQUINA, maquina, 'Máquina creada', thenHandler);
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_DETALLES_NEW_MAQUINA, payload: id })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'vmaquinadetalle/', maquina,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_DETALLES_NEW_MAQUINA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Nueva máquina creada!' },
    //             dialogid: 'success_update_new_maquina_' + id
    //         });
    //     }).catch((error) => {
    //         if (error.response.status === 409) {

    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_new_maquina_' + id
    //             });
    //         }
    //         else {
    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_new_maquina_' + id
    //             });
    //         };
    //     });
    // };


};


//acc_mover_maquinas:
export function getMaquinasCentroOrigen(centroId) {
    return getData(`vmaquinas/vmaquinasalta?centro_id=${centroId}`, GET_MAQUINAS_CENTRO_ORIGEN);
};

export function getMaquinasCentroDestino(centroId) {
    return getData(`vmaquinas/vmaquinasalta?centro_id=${centroId}`, GET_MAQUINAS_CENTRO_DESTINO);
};

//post:
export function moveMaquinaToCentroDestino(arrayIds, centroOrigenId, centroDestinoId, fecha) {

    // return (dispatch, getState) => {
    //     dispatch({ type: MOVE_MAQUINA_TO_CENTRO_DESINO, payload: arrayIds })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + `vmaquinas/vmaquinasalta/movermaquinas?centro_origen=${centroOrigenId}&centro_destino=${centroDestinoId}&date=${fecha}`, arrayIds,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: MOVE_MAQUINA_TO_CENTRO_DESINO + "_SUCCESS", payload: response })
    //     }).catch((error) => {
    //         if (error.response.status === 409) {

    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_moving_maquinas_' + arrayIds
    //             });
    //         }
    //         else {
    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_moving_maquinas_' + arrayIds
    //             });
    //         };
    //     });
    // };

    return postData(
        `vmaquinas/vmaquinasalta/movermaquinas?centro_origen=${centroOrigenId}&centro_destino=${centroDestinoId}&date=${fecha}`,
        MOVE_MAQUINA_TO_CENTRO_DESINO,
        arrayIds,
        undefined,
        undefined
    );

};
